let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jKfo4")).then(() => parcelRequire('d4laO'));